import createDataContext from "./createDataContext";
import { db, auth } from "../firebase";

// const login = async () => {
//   auth
//     .signInWithEmailAndPassword("thjeon.wa@gmail.com", "yesyesyes")
//     .then(() => {
//       return true;
//     })
//     .catch(function (error) {
//       // Handle Errors here.
//       var errorCode = error.code;
//       var errorMessage = error.message;
//       console.log(errorMessage);
//       return false;
//     });
// };

const streetReducer = (state, action) => {
  switch (action.type) {
    case "add_key":
      return { ...state, streetID: action.payload };
    case "add_imageFile":
      return { ...state, imageFile: action.payload };
    case "add_streetName":
      return { ...state, streetName: action.payload };
    case "add_location":
      return { ...state, location: action.payload };
    case "get_photo":
      return {
        ...state,
        streetID: action.payload.streetID,
        imageFile: action.payload.imageFile,
        location: action.payload.location,
        streetName: action.payload.streetName,
      };
    case "save_photo":
      return { ...state, saveStatus: action.payload };

    case "get_photos":
      return { ...state, photos: action.payload };
    case "get_instagram":
      return { ...state, instagrams: action.payload };
    default:
      return state;
  }
};

const setStreetID = (dispatch) => (streetID) => {
  dispatch({ type: "add_key", payload: streetID });
};

const setStreetName = (dispatch) => (streetName) => {
  dispatch({ type: "add_streetName", payload: streetName });
};

const setLocation = (dispatch) => (location) => {
  dispatch({ type: "add_location", payload: location });
};

const setImageFile = (dispatch) => (fileURL) => {
  dispatch({ type: "add_imageFile", payload: fileURL });
};

const savePhoto = (dispatch) => async (
  streetID,
  streetName,
  location,
  imageFile
) => {
  // const db = firebaseApp.firestore();
  // need to add save routine to firbase
  auth
    .signInWithEmailAndPassword("thjeon.wa@gmail.com", "yesyesyes")
    .catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorCode, errorMessage);
      return;
    });

  const time = Date.now();

  let aPhoto = {
    streetName: streetName,
    location: location,
    imageFile: imageFile,
    confirmed: false,
    register_time: time,
  };

  db.collection("photos")
    .doc(streetID)
    .set(aPhoto)
    .then(() => {
      console.log("photo saved");
      dispatch({ type: "save_photo", payload: "OK" });
    })
    .catch((error) => {
      console.log("error", error);
      dispatch({ type: "save_photo", payload: error });
    });
};

const getPhoto = (dispatch) => async (streetID) => {
  console.log("getPhoto with " + streetID);

  auth
    .signInWithEmailAndPassword("thjeon.wa@gmail.com", "yesyesyes")
    .catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorCode, errorMessage);
      return;
    });

  const data = await db.collection("photos").get();
  console.log(data);
  dispatch({ type: "get_photos", payload: data });
};

const getPhotos = (dispatch) => async () => {
  console.log("Get Photos");
  auth
    .signInWithEmailAndPassword("thjeon.wa@gmail.com", "yesyesyes")
    .catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorCode, errorMessage);
      return;
    });

  await db
    .collection("photos")
    .get()
    .then((snapshot) => {
      const data = snapshot.docs.map((doc) => doc.data());
      dispatch({ type: "get_photos", payload: data });
    });
};

const getInstagrams = (dispatch) => async () => {
  console.log("Get Instagrams");
  auth
    .signInWithEmailAndPassword("thjeon.wa@gmail.com", "yesyesyes")
    .catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorCode, errorMessage);
      return;
    });

  await db
    .collection("insta")
    .get()
    .then((snapshot) => {
      const data = snapshot.docs.map((doc) => doc.data());
      dispatch({ type: "get_instagram", payload: data });
    });
};

export const { Context, Provider } = createDataContext(
  streetReducer,
  {
    setStreetID,
    setStreetName,
    setLocation,
    setImageFile,
    savePhoto,
    getPhoto,
    getPhotos,
    getInstagrams,
  },
  {
    streetID: "",
    streetName: "",
    location: null,
    imageFile: "",
    confirmed: false,
  }
);
